/* eslint-disable  @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Config } from 'datatables.net';
import Swal from 'sweetalert2';
import { NavbarComponent } from '../../../navbar/navbar.component';
import { isAfter, isBefore, isSameDay } from 'date-fns';
import moment from 'moment';
import { RosterFormComponent } from '../roster-form/roster-form.component';

@Component({
	selector: 'app-roster-list',
	templateUrl: './roster-list.component.html',
	styleUrl: './roster-list.component.scss'
})
export class RosterListComponent implements OnInit, AfterViewInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/roster",
			name: "Rosters"
		}
	];

	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	dtOptions: Config = {};
	dataList: any = [];
	showDeleteLoader: any = null;
	showApproveLoader: any = null;
	pagetitle = "Roster";
	pageLoading = false;
	userList: any[] = [];
	/* filters: any = {
		emp_code: null
	} */
	@ViewChild(RosterFormComponent) form!: RosterFormComponent;

	constructor(private formBuilder: FormBuilder, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private http: HttpClient, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	ngOnInit(): void { }

	ngAfterViewInit(): void {
		this.apiService.userList$.subscribe((userList) => {
			if (userList) {
				this.userList = userList.filter((u) => u.emp_code);
			}
		});
		this.initDatatable();
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			language: {
				searchPlaceholder: "Search",
				search: ""
			},
			ajax: (dataTablesParameters: any, callback) => {
				const data: any = {
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value || ""
				}
				this.apiService.getRoster(data).subscribe({
					next: (response: any) => {
						this.dataList = response.data;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered,
							data: []
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong.", 'Error!!!', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	deleteConfirm(uId: any) {
		Swal.fire({
			title: 'Warning !!!',
			html: 'Are you sure you want to delete record?',
			icon: 'warning',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Delete',
			cancelButtonText: 'Cancel',
			confirmButtonColor: '#dc3545'
		}).then((result) => {
			if (result.value) {
				this.showDeleteLoader = uId;
				this.apiService.deleteRoster(uId).subscribe({
					next: () => {
						this.showDeleteLoader = null;
						Swal.fire('Success', 'Deleted successfully.', 'success');
						this.refreshTable();
					}, error: (error) => {
						this.showDeleteLoader = null;
						if (error.status == 401) { return }
						if (error.status == 404) {
							Swal.fire('Error', error.error, 'error');
						} else {
							Swal.fire('Error', 'Something went wrong.', 'error');
						}
					}
				});
			}
		})
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	createEdit(obj: any) {
		this.form.initForm(obj);
	}
}
